import { eIconType, I18NString } from "../../features/common"
import { getSpriteLink, printMultilangString } from "../../services/utils"
import { IModelSelectProps } from "./ModeSelect"

var inDevelopmentString:I18NString = {
        ru: "Карта для сценария Бакалавра в разработке.",
        en: "The Bachelor's scenario map is in development."
    }   

const BachelorStub = ({activeLang}:IModelSelectProps) => {
    return <div className="interactive-map__menu--stub-bachelor">
        <img className="img" src={getSpriteLink(eIconType.MapMenuBg,'under-construction-sign')}/>
        <div className="text">{printMultilangString(inDevelopmentString, activeLang)}</div>
    </div>
}

export default BachelorStub